export function getScript(url: string) {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject('getScript need url');
      return;
    }
    const script = document.createElement('script');
    script.addEventListener(
      'load',
      () => {
        resolve();
      },
      false,
    );
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', url);
    document.getElementsByTagName('head')[0].appendChild(script);
  });
}

export function getStyle(url: string) {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject('getStyle need url');
      return;
    }
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', url);
    link.setAttribute('type', 'text/css');
    document.getElementsByTagName('head')[0].appendChild(link);
    link.addEventListener(
      'load',
      () => {
        resolve();
      },
      false,
    );
  });
}

export const test1 = () => {
  getScript('https://img.ssl.msdk.qq.com/wiki/msdkJsAdapter.js');
};
